// Use in a `default` case so the compiler flags an unhandled union member.
// source: https://github.com/palantir/tslint/issues/696#issuecomment-468640023
export const unreachableCase = (v: never): never => {
  throw new Error(`Reached an unreachable case: ${JSON.stringify(v)}`)
}

// we want to safely handle (rather than crash) some unreachable cases, for things like backend-generated
// string unions that may be added to in the future.
export const safeUnreachableCase = <T>(v: never, retVal: T): T => {
  // notifyBugsnag(
  //   {
  //     errorClass: 'bug',
  //     errorMessage: `Reached an unreachable case: ${v}. Perhaps you need to generate types for the frontend?`,
  //   },
  //   {
  //     metaData: {
  //       unreachableCase: v,
  //     },
  //   }
  // )
  console.error(`Reached an unreachable case: ${JSON.stringify(v)}`)
  return retVal
}
